/**
 * Captastic — collection Colour filter card images (JS fallback).
 * Liquid already swaps media when primary_colour tags / filters are active.
 * This covers Section Rendering / late DOM updates: read primary_colour-* from
 * the path (and Colour chips), then swap each card img from data-captastic-colour-map.
 * UK spelling Colour. Does not blank images when no match.
 */
(function () {
  var FAMILY = {
    green: ['olive', 'bottle', 'forest', 'army', 'pine', 'moss', 'sage', 'mint', 'cypress', 'eucalyptus', 'leaf', 'green'],
    blue: ['navy', 'royal', 'cobalt', 'petrol', 'sapphire', 'turquoise', 'denim', 'avio', 'hydro', 'ink', 'blue'],
    red: ['burgundy', 'maroon', 'cardinal', 'rust', 'fire', 'red'],
    brown: ['khaki', 'beige', 'stone', 'sand', 'camel', 'copper', 'mushroom', 'walnut', 'taupe', 'ecru', 'bone', 'natural', 'clay', 'brown'],
    grey: ['grey', 'gray', 'charcoal', 'graphite', 'silver', 'heather', 'asphalt', 'anthracite', 'melange'],
    gray: ['grey', 'gray', 'charcoal', 'graphite', 'silver', 'heather', 'asphalt', 'anthracite', 'melange'],
    black: ['black', 'midnight'],
    white: ['white', 'ivory'],
    yellow: ['yellow', 'mustard', 'fluo', 'neon', 'citrus', 'lemonade', 'butter', 'gold'],
    orange: ['orange', 'coral'],
    pink: ['pink', 'fuchsia', 'orchid', 'rose', 'lilac', 'bubblegum'],
    purple: ['purple', 'violet', 'lilac'],
    neutral: ['cream', 'ecru', 'bone', 'natural', 'neutral'],
    pattern: ['camo', 'stripe', 'check', 'multi', 'tie']
  };

  function activeColoursFromPath() {
    var path = window.location.pathname || '';
    // /collections/x/brand-atlantis+primary_colour-green+type-beanie
    var m = path.match(/\/collections\/[^/]+\/([^/?#]+)/);
    if (!m) return [];
    var parts = decodeURIComponent(m[1]).split('+');
    var out = [];
    parts.forEach(function (p) {
      var mm = p.match(/^primary_colour-(.+)$/i);
      if (mm) out.push(mm[1].replace(/-/g, ' ').toLowerCase());
    });
    return out;
  }

  function activeColoursFromChips() {
    var out = [];
    document.querySelectorAll('.captastic-facet-row[data-facet="colour"] .captastic-chip--active').forEach(function (a) {
      var t = (a.textContent || '').trim().toLowerCase();
      if (t) out.push(t);
    });
    return out;
  }

  function matchSrc(map, active) {
    if (!map || !active) return null;
    var keys = Object.keys(map);
    var i, k, kl, fam, j;
    for (i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === active) return map[keys[i]];
    }
    for (i = 0; i < keys.length; i++) {
      kl = keys[i].toLowerCase();
      if (kl.indexOf(active) !== -1) return map[keys[i]];
    }
    fam = FAMILY[active] || [active];
    for (i = 0; i < keys.length; i++) {
      kl = keys[i].toLowerCase();
      for (j = 0; j < fam.length; j++) {
        if (kl.indexOf(fam[j]) !== -1) return map[keys[i]];
      }
    }
    return null;
  }

  function apply() {
    var actives = activeColoursFromPath();
    if (!actives.length) actives = activeColoursFromChips();
    if (!actives.length) return;

    document.querySelectorAll('.product-card-wrapper[data-captastic-colour-map]').forEach(function (card) {
      var raw = card.getAttribute('data-captastic-colour-map');
      if (!raw) return;
      var map;
      try {
        map = JSON.parse(raw);
      } catch (e) {
        return;
      }
      var src = null;
      var a;
      for (a = 0; a < actives.length; a++) {
        src = matchSrc(map, actives[a]);
        if (src) break;
      }
      if (!src) return;
      var img = card.querySelector('img[data-captastic-card-media], .card__media img');
      if (!img) return;
      if (img.getAttribute('src') === src) return;
      img.setAttribute('src', src);
      // Drop stale srcset so browser uses src
      img.removeAttribute('srcset');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  document.addEventListener('shopify:section:load', apply);
  // Dawn filter / facet re-renders
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('facet-filters-form, .captastic-facets')) {
      setTimeout(apply, 50);
    }
  });
})();
